import React from 'react';
import styled from 'styled-components';
import CardBrandIcon from './CardBrandIcon';

const MethodNumber = styled.span`
  margin-left: 8px;
`;

const PaymentMethodContainer = styled.div`
  align-items: center;
  display: flex;
`;

type paymentMethodLabelType = {
  cardNumber: string;
  cardBrand: string;
};

const PaymentMethodLabel = ({ cardNumber, cardBrand }: paymentMethodLabelType) => {
  return (
    <PaymentMethodContainer>
      <CardBrandIcon cardBrand={cardBrand} />
      <MethodNumber>*{cardNumber}</MethodNumber>
    </PaymentMethodContainer>
  );
};

export default PaymentMethodLabel;
